import type { LegalDoc } from '@/data/legal/types';

export default function LegalPage({ doc }: { doc: LegalDoc }) {
  return (
    <section className="w-full bg-background-50 px-4 md:px-8 lg:px-12 pt-32 md:pt-44 pb-20 md:pb-28">
      <div className="max-w-content mx-auto max-w-3xl">
        <span className="font-label text-xs uppercase tracking-widest2 text-primary-400">KOR38</span>
        <h1 className="mt-4 font-heading text-3xl md:text-4xl leading-tight text-primary-400">
          {doc.title}
        </h1>
        <p className="mt-3 font-label text-xs uppercase tracking-[0.14em] text-foreground-500">
          Last updated: {doc.lastUpdated}
        </p>

        <div className="mt-10 space-y-8">
          {doc.sections.map((section, i) => (
            <section key={i}>
              <h2 className="font-heading text-lg md:text-xl text-primary-300">{section.heading}</h2>
              {section.blocks.length > 0 ? (
                <div className="mt-3 space-y-3 text-base leading-relaxed text-foreground-800">
                  {section.blocks.map((block, j) =>
                    'p' in block ? (
                      <p key={j}>{block.p}</p>
                    ) : (
                      <ul key={j} className="list-disc pl-5 space-y-2">
                        {block.list.map((item, k) => (
                          <li key={k}>{item}</li>
                        ))}
                      </ul>
                    ),
                  )}
                </div>
              ) : null}
            </section>
          ))}
        </div>
      </div>
    </section>
  );
}